import type { GeocodeAddressInput, LatLng, MapyGeocodeItem } from './types'

function getApiKey(): string {
  const key = import.meta.env.VITE_MAPY_API_KEY
  if (!key) {
    throw new Error('VITE_MAPY_API_KEY is not configured')
  }
  return key
}

export function formatAddressQuery(address: GeocodeAddressInput): string {
  return [address.street, address.zip, address.city, address.country]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(', ')
}

export async function geocodeAddress(
  address: GeocodeAddressInput,
  signal?: AbortSignal,
): Promise<LatLng | null> {
  const query = formatAddressQuery(address)
  if (query.length < 3) return null

  const url = new URL('https://api.mapy.com/v1/geocode')
  url.searchParams.set('query', query)
  url.searchParams.set('lang', 'cs')
  url.searchParams.set('limit', '1')
  url.searchParams.set('apikey', getApiKey())

  const res = await fetch(url, {
    headers: { Accept: 'application/json' },
    signal,
  })

  if (!res.ok) {
    throw new Error(`Mapy geocode failed: ${res.status}`)
  }

  const data = (await res.json()) as { items?: MapyGeocodeItem[] }
  const item = data.items?.[0]
  const lat = item?.position?.lat
  const lon = item?.position?.lon

  if (typeof lat !== 'number' || typeof lon !== 'number') {
    return null
  }

  return { latitude: lat, longitude: lon }
}
